class BirthdayCombos {
  constructor() {
    this.section = document.querySelector(".birthday-combos");

    if (!this.section) return;

    this.tabs = this.section.querySelectorAll(".birthday-tab");
    this.cards = this.section.querySelectorAll(".birthday-card");
    this.slider = this.section.querySelector(".birthday-slider");

    this.initTabs();
    this.makeCardsClickable();
  }

  initTabs() {
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        this.activateTab(tab.dataset.category, true);

        this.tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
      });
    });

    // Show first category WITHOUT triggering click or scrolling
    const firstCategory = this.tabs[0]?.dataset.category;

    if (firstCategory) {
      this.activateTab(firstCategory, false);
      this.tabs[0].classList.add("active");
    }
  }

  activateTab(category, shouldScroll = false) {
    let firstVisibleCard = null;

    this.cards.forEach((card) => {
      if (card.dataset.category === category) {
        card.style.display = "";

        if (!firstVisibleCard) {
          firstVisibleCard = card;
        }
      } else {
        card.style.display = "none";
      }
    });

    if (
      shouldScroll &&
      firstVisibleCard &&
      window.innerWidth < 750
    ) {
      firstVisibleCard.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }

  makeCardsClickable() {
    this.cards.forEach((card) => {
      const button = card.querySelector("button");
      const form = card.querySelector("form");
      const links = card.querySelectorAll("a");

      // Prevent buttons/forms from triggering card click
      if (button) {
        button.addEventListener("click", (e) => e.stopPropagation());
      }

      if (form) {
        form.addEventListener("click", (e) => e.stopPropagation());
      }

      links.forEach((link) => {
        link.addEventListener("click", (e) => e.stopPropagation());
      });

      card.addEventListener("click", () => {
        const url = card.dataset.productUrl;

        if (url) {
          window.location.href = url;
        }
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new BirthdayCombos();
});